module.exports = __webpack_public_path__ + "img/Zelfbouw met begeleiding.5c5fec66.svg";